<h1 id="nhed">
  <a routerLink="" class="logo-a">
    <img src="{{doaminName+schoolData.logo}}" style="font-size: 34px;" id="logo" alt="{{schoolData.name}}">
    <span class="school-name">
      <p>{{schoolData.name}}</p>
    </span>
  </a>
</h1>
